import React, { useRef, useState, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ALERT_TYPE, REQUEST_METHOD, ShowToastMessage, sequenceActionNext } from '@laramie/ui';
import {
  TableCustom,
  Loading,
  SectionHeading,
  WrapperAdvancedSearch,
} from "../../components/common";
import { useEntidad } from "../../components/hooks/useEntidad";
import VariableGlobalModal from "../../components/controls/VariableGlobalModal";
import VariableModal from "../../components/controls/VariableModal";
import VariablesGlobalGrid from "../../components/controls/VariablesGlobalGrid";
import EntidadesModal from "../../components/controls/EntidadesModal";
import { getDateNow, getFormatValueGrid } from "../../utils/convert";
import { ServerRequest } from "../../utils/apiweb";
import { APIS } from "../../config/apis";
import { isNull } from "../../utils/validator";
import { useAccess } from "../../components/hooks/useAccess";
import {TIPS} from "../../consts/tips";

function VariablesGlobalesView() {
  const [state, setState] = useState({
    loading: false,
    showMessage: false,
    showForm: false,
    showVariables: false,
    showFormVariableGlobalModal: false,
    showFormVariableModal: false,
    rowFormVariableGlobal: null,
    rowIdVariable: null,
    modeFormEdit: false,
    rowId: 0,
    listVariable: [],
    listVariableGlobal: [],
  });

  const [tableVisible, setTableVisible] = useState(false);
  const [rangoSolapado, setRangoSolapado] = useState(null);

  const searchRef = useRef();

  const dispatch = useDispatch();
  const sequenceValue = useSelector((state) => state.sequence.value);

  const [getListEntidad] = useEntidad({
    entidades: ["Variable"],
    onLoaded: (entidades, isSuccess, error) => {
      if (isSuccess) {
        SearchVariablesGlobales();
        const list = getListEntidad("Variable").filter((x) => x.global);
        setState((prev) => ({ ...prev, listVariable: list }));
      } else {
        ShowToastMessage(ALERT_TYPE.ALERT_ERROR, error);
      }
    },
    memo: null,
  });

  const [hasEditAccess, setHasEditAccess] = useState(false);
  useAccess({
    key: "VariablesGlobalesView",
    onLoaded: (data, isSuccess, error) => {
      if (!isSuccess) ShowToastMessage(ALERT_TYPE.ALERT_ERROR, error);
      else setHasEditAccess(data.some((x) => x.codigo === "variable_edit"));
    },
  });

  let listVariableVisible = useMemo(() => {
    if (state.listVariableGlobal && state.listVariableGlobal.length !== 0) {
      const listVariableId = state.listVariableGlobal.map((x) => x.idVariable);
      return state.listVariable.filter(
          (f) => f.predefinido || listVariableId.includes(f.id)
      );
    }
  }, [state.listVariableGlobal, state.listVariable]);

  const getVariableValor = (id) => {
    const today = getDateNow();
    let currentValue = "";
    if (state.listVariableGlobal.length > 0) {
      const listVariableGlobalXVariable = state.listVariableGlobal.filter(
          (f) => f.idVariable === id
      );
      const currentRow = listVariableGlobalXVariable.find(
          (x) =>
              (x.fechaDesde <= today || isNull(x.fechaDesde)) &&
              (x.fechaHasta >= today || isNull(x.fechaHasta))
      );
      if (!isNull(currentRow)) {
        const variable = state.listVariable.find((f) => f.id === id);
        if (variable) {
          currentValue = getFormatValueGrid(
              currentRow.valor,
              variable.tipoDato,
              true
          );
        }
      }
    }
    return currentValue;
  };

  const cellA = (data) =>
      !hasEditAccess ? (
          ""
      ) : (
          <div className="action">
            <div onClick={() => handleClickVariableAdd()} className="link">
          <span className="material-symbols-outlined" title="Nuevo">
            add
          </span>
            </div>
          </div>
      );

  const cellV = (data) => (
      <div className="action">
        <div onClick={() => handleClickVariableView(data.value)} className="link">
        <span className="material-symbols-outlined" title="Ver">
          search
        </span>
        </div>
      </div>
  );

  const cellE = ({ row }) => (
      <div
          className="action"
          {...row.getToggleRowExpandedProps({ title: "ver historial de cambios" })}
      >
        <div className="link">
          {row.isExpanded ? (
              <span className="material-symbols-outlined icon-expanded">
            expand_more
          </span>
          ) : (
              <span className="material-symbols-outlined">chevron_right</span>
          )}
        </div>
      </div>
  );

  const tableColumns = [
    {
      Header: "",
      Cell: cellE,
      id: "expander",
      width: "3%",
      disableGlobalFilter: true,
      disableSortBy: true,
    },
    { Header: "Código", accessor: "codigo", width: "30%" },
    { Header: "Descripción", accessor: "descripcion", width: "37%" },
    {
      Header: "Valor actual",
      Cell: (props) => getVariableValor(props.row.original.id),
      id: "valorActual",
      accessor: "id",
      width: "10%",
    },
    {
      Header: "Activo",
      Cell: (props) => (props.row.original.activo ? "Sí" : "No"),
      id: "activo",
      accessor: "id",
      width: "10%",
    },
    {
      Header: cellA,
      Cell: cellV,
      id: "abm",
      accessor: "id",
      width: "10%",
      disableGlobalFilter: true,
      disableSortBy: true,
    },
  ];

  const subComponent = ({ row }) => (
      <div className="form-sub-component">
        <div className="row">
          <div className="col-12 col-lg-8 p-top-15">
            <label className="form-label">Historial de cambios</label>
            <VariablesGlobalGrid
                disabled={!row.original.activo}
                data={{
                  idVariable: row.original.id,
                  list: state.listVariableGlobal.filter(
                      (f) => f.idVariable === row.original.id
                  ),
                }}
                onChange={(row) => {
                  ActionVariableGlobal(row);
                }}
            />
          </div>
        </div>
      </div>
  );

  const handleClickVariableAdd = () => {
    setState((prevState) => ({ ...prevState, showVariables: true }));
  };

  const handleClickVariableView = (id) => {
    setState((prevState) => ({
      ...prevState,
      showFormVariableModal: true,
      rowIdVariable: parseInt(id),
    }));
  };

  const handleClickVariableGlobalAdd = (idVariable) => {
    const idTemporal = -1 * sequenceValue;
    setState((prevState) => {
      const rowFormVariableGlobal = {
        id: idTemporal,
        idVariable,
        valor: "",
        fechaDesde: null,
        fechaHasta: null,
      };
      return {
        ...prevState,
        showVariables: false,
        showFormVariableGlobalModal: true,
        rowFormVariableGlobal,
      };
    });
    dispatch(sequenceActionNext());
  };

  function SearchVariables(filterFunc = null) {
    setState((prev) => ({ ...prev, loading: true, listVariable: [] }));

    const callbackSuccess = (response) => {
      response
          .json()
          .then((data) => {
            let list = filterFunc ? filterFunc(data) : data;
            // keep only global variables
            list = list.filter((x) => x.global);
            setState((prev) => ({
              ...prev,
              loading: false,
              listVariable: list,
            }));
            setTableVisible(true);
          })
          .catch((error) => {
            ShowToastMessage(
                ALERT_TYPE.ALERT_ERROR,
                "Error procesando respuesta: " + error
            );
            setState((prevState) => ({ ...prevState, loading: false }));
          });
    };

    ServerRequest(
        REQUEST_METHOD.GET,
        null,
        true,
        APIS.URLS.VARIABLE,
        null,
        null,
        callbackSuccess,
        (res) => {
          res.json().then((error) => {
            ShowToastMessage(ALERT_TYPE.ALERT_ERROR, error.message);
            setState((prevState) => ({ ...prevState, loading: false }));
          });
        },
        (error) => {
          ShowToastMessage(
              ALERT_TYPE.ALERT_ERROR,
              "Error procesando solicitud: " + error.message
          );
          setState((prevState) => ({ ...prevState, loading: false }));
        }
    );
  }

  function SearchVariablesGlobales() {
    setState((prev) => ({ ...prev, loading: true, listVariableGlobal: [] }));

    const callbackSuccess = (response) => {
      response
          .json()
          .then((data) => {
            data.forEach((x) => {
              if (x.fechaDesde) x.fechaDesde = new Date(x.fechaDesde);
              if (x.fechaHasta) x.fechaHasta = new Date(x.fechaHasta);
            });
            setState((prev) => ({
              ...prev,
              loading: false,
              listVariableGlobal: data,
            }));
          })
          .catch((error) => {
            ShowToastMessage(
                ALERT_TYPE.ALERT_ERROR,
                "Error procesando respuesta: " + error
            );
            setState((prevState) => ({ ...prevState, loading: false }));
          });
    };

    ServerRequest(
        REQUEST_METHOD.GET,
        null,
        true,
        APIS.URLS.VARIABLE_GLOBAL,
        null,
        null,
        callbackSuccess,
        (res) => {
          res.json().then((error) => {
            ShowToastMessage(ALERT_TYPE.ALERT_ERROR, error.message);
            setState((prevState) => ({ ...prevState, loading: false }));
          });
        },
        (error) => {
          ShowToastMessage(
              ALERT_TYPE.ALERT_ERROR,
              "Error procesando solicitud: " + error.message
          );
          setState((prevState) => ({ ...prevState, loading: false }));
        }
    );
  }

  function ActionVariableGlobal(row) {
    const action = row.state;
    delete row.state;
    switch (action) {
      case "a":
        AddVariableGlobal(row);
        break;
      case "m":
        ModifyVariableGlobal(row);
        break;
      case "r":
        RemoveVariableGlobal(row);
        break;
      default:
        break;
    }
  }

  function AddVariableGlobal(row) {
    const method = REQUEST_METHOD.POST;
    const paramsUrl = null;
    SaveVariableGlobal(method, paramsUrl, row);
  }

  function ModifyVariableGlobal(row) {
    const method = REQUEST_METHOD.PUT;
    const paramsUrl = `/${row.id}`;
    SaveVariableGlobal(method, paramsUrl, row);
  }

  function RemoveVariableGlobal(row) {
    const method = REQUEST_METHOD.DELETE;
    const paramsUrl = `/${row.id}`;
    SaveVariableGlobal(method, paramsUrl);
  }

  function SaveVariableGlobal(method, paramsUrl, dataBody = null) {
    setState((prev) => ({ ...prev, loading: true }));

    const callbackSuccess = (response) => {
      response
          .json()
          .then(() => {
            SearchVariablesGlobales();
            setState((prev) => ({ ...prev, loading: false }));
          })
          .catch((error) => {
            ShowToastMessage(
                ALERT_TYPE.ALERT_ERROR,
                "Error procesando respuesta: " + error
            );
            setState((prev) => ({ ...prev, loading: false }));
          });
    };

    ServerRequest(
        method,
        null,
        true,
        APIS.URLS.VARIABLE_GLOBAL,
        paramsUrl,
        dataBody,
        callbackSuccess,
        (res) => {
          res.json().then((error) => {
            ShowToastMessage(ALERT_TYPE.ALERT_ERROR, error.message);
            setState((prev) => ({ ...prev, loading: false }));
          });
        },
        (error) => {
          ShowToastMessage(
              ALERT_TYPE.ALERT_ERROR,
              "Error procesando solicitud: " + error.message
          );
          setState((prev) => ({ ...prev, loading: false }));
        }
    );
  }

  function ValidateVariableGlobal(row) {
    const listOthers = state.listVariableGlobal.filter(
        (f) => f.idVariable === row.idVariable && f.id !== row.id
    );

    const conflicts = listOthers.filter(
        (f) =>
            (f.fechaDesde <= row.fechaHasta || isNull(f.fechaDesde) || isNull(row.fechaHasta)) &&
            (f.fechaHasta >= row.fechaDesde || isNull(f.fechaHasta) || isNull(row.fechaDesde))
    );

    return conflicts.length === 0;
  }

  function onSearch() {
    SearchVariables(FilterVariables);
  }

  function FilterVariables(data) {
    const { codigo, activo } = searchRef.current?.filters || {};

    let newList = [...data];

    if (codigo && codigo.length > 0) {
      newList = newList.filter((f) => 
        `${f.codigo}|${f.descripcion}`.toLowerCase().indexOf(codigo.toLowerCase()) >= 0
      );
    }

    if (activo) {
      newList = newList.filter((f) => f.activo);
    }

    return newList;
  }

  return (
      <>
        <Loading visible={state.loading} />

        <SectionHeading
            titles={[{ title: "Configuración" }, { title: "Variables globales" }]}
            onAddClick={hasEditAccess? handleClickVariableAdd : null}
            tableVisible={tableVisible}
        />

        <section className="section-accordion">
          <WrapperAdvancedSearch
              ref={searchRef}
              filters={[
                {
                  title: "Código / Descripción",
                  field: "codigo",
                  type: "string",
                  size: 6,
                  searchOnEnter: true,
                },
                {
                  title: "Estado",
                  field: "activo",
                  type: "selectLista",
                  size: 3,
                  options: [
                    { value: null, label: "Todos" },
                    { value: true, label: "Activos" },
                  ],
                },
              ]}
              onSearch={onSearch}
          />

          <div className="m-top-20">
            {state.showVariables && (
                <EntidadesModal
                    title="Seleccione el tipo de variable a completar"
                    tipName={TIPS.NAME.MODALS.SELECCION_TIPO_VARIABLE_MODAL}
                    entidad="Variable"
                    onDismiss={() =>
                        setState((prev) => ({ ...prev, showVariables: false }))
                    }
                    onConfirm={(id) => handleClickVariableGlobalAdd(id)}
                    filter={(row) => row.activo && row.global}
                    columns={[
                      { Header: "Código", accessor: "codigo", width: "25%" },
                      { Header: "Descripción", accessor: "descripcion", width: "50%" },
                    ]}
                    showWithoutSelection={false}
                    memo={null}
                />
            )}

            {state.showFormVariableModal && (
                <VariableModal
                    id={state.rowIdVariable}
                    disabled={true}
                    onDismiss={() => {
                      setState((prev) => ({ ...prev, showFormVariableModal: false }));
                    }}
                    onConfirm={() => {}}
                />
            )}

            {state.showFormVariableGlobalModal && (
                <VariableGlobalModal
                    disabled={false}
                    data={{
                      entity: state.rowFormVariableGlobal,
                    }}
                    rangoSolapado={rangoSolapado}
                    solapaOtroValor={!ValidateVariableGlobal(state.rowFormVariableGlobal)}
                    onDismiss={() => {
                      setRangoSolapado(null);
                      setState((prev) => ({
                        ...prev,
                        showFormVariableGlobalModal: false,
                        rowFormVariableGlobal: null,
                      }));
                    }}
                    onConfirm={(row) => {
                      if (ValidateVariableGlobal(row)) {
                        setRangoSolapado(null);
                        setState((prev) => ({
                          ...prev,
                          showFormVariableGlobalModal: false,
                          rowFormVariableGlobal: null,
                        }));
                        AddVariableGlobal(row);
                      } else {
                        setRangoSolapado({fechaDesde: row.fechaDesde, fechaHasta: row.fechaHasta});
                      }
                    }}
                />
            )}

            {tableVisible && (
                <TableCustom
                    showFilterGlobal={false}
                    className="TableCustomBase"
                    columns={tableColumns}
                    data={listVariableVisible}
                    messageEmpty="No se encontraron resultados"
                    subComponent={subComponent}
                />
            )}
          </div>
        </section>
      </>
  );
}

export default VariablesGlobalesView;
